import speakingurl from 'speakingurl'
import OtherProject, { NON_POWER_PROJECT_TYPES } from './OtherProject'

class GeothermalProject extends OtherProject {
  constructor (obj) {
    super(obj)

    this.type = 'Geothermal'
    this.name = obj.Facility
    this.owner = ''
    this.operator = ''
    this.id = speakingurl(`${this.name}`)

    this.city = obj.City

    this._type = NON_POWER_PROJECT_TYPES['Geothermal']
    this.typeShortName = this._type.shortName
    this.icon = this._type.icon
  }
}

export default GeothermalProject



// WEBPACK FOOTER //
// ./src/models/GeothermalProject.js